import { Container, Divider, Grid, Paper } from "@mui/material";
import React, { useEffect } from "react";
import { lsDelete, lsGet, Model, UseForm } from "hooks";
import PrintItems from "./PrintItems";
import PreviewLabel from "./PreviewLabel";
import InputFields from "./InputFields";
import Header from "./Header";
import { SearchProduct } from ".";

const PrintLabelForm = () => {
  const { PrintLabelMdl } = Model();
  const { values, setValues, handleInpChg, handleInpCheck } =
    UseForm(PrintLabelMdl);

  useEffect(() => {
    const purchaseLables = lsGet("printPurchaseLabels");
    if (purchaseLables !== null) {
      setValues((prev) => ({
        ...prev,
        items: purchaseLables?.items || [],
      }));
      lsDelete("printPurchaseLabels");
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Container>
        <Paper>
          <Header {...{ values, setValues }} />
          <Divider />
          <div className="p-[15px] mt-[10px]">
            <Grid container spacing={2}>
              {/* ---------- Input Fields ---------- */}
              <Grid item xs={12} lg={8}>
                <InputFields
                  {...{ values, setValues, handleInpCheck, handleInpChg }}
                />
              </Grid>
              {/* ---------- Preview Label ---------- */}
              <Grid item xs={12} lg={4}>
                <PreviewLabel {...{ values }} />
              </Grid>
              {/* ---------- Select Product ---------- */}
              <Grid item xs={12}>
                <SearchProduct {...{ values, setValues }} />
              </Grid>
              {/* ---------- Print Items ---------- */}
              <Grid item xs={12}>
                <PrintItems {...{ values, setValues }} />
              </Grid>
            </Grid>
          </div>
        </Paper>
      </Container>
    </>
  );
};

export default PrintLabelForm;
